module.exports = __webpack_public_path__ + "img/vc.9c36dcc9.jpg";